import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Connect from "./Connect";
import "../styles/Header.css";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location?.pathname || "/";
  const [isConnectOpen, setIsConnectOpen] = useState(false);
  const isAdminAuthenticated =
    localStorage.getItem("adminAuthenticated") === "true";

  const handleLogout = () => {
    localStorage.removeItem("adminAuthenticated");
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <header className="app-header">
        <nav className="main-nav">
          <Link to="/" className="logo">
            Bella Toka
          </Link>
          <ul className="nav-links">
            <li>
              <Link to="/" className={pathname === "/" ? "active" : ""}>
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={pathname === "/about" ? "active" : ""}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/admin"
                className={pathname === "/admin" ? "active" : ""}
              >
                Admin
              </Link>
            </li>
            <li>
              <Link
                to="/facility"
                className={pathname === "/facility" ? "active" : ""}
              >
                Facility
              </Link>
            </li>
            {!isAdminAuthenticated && (
              <li>
                <button
                  className={`connect-btn ${
                    pathname === "/admin" ? "hidden-on-admin" : ""
                  }`}
                  onClick={() =>
                    pathname !== "/admin" && setIsConnectOpen(true)
                  }
                  style={
                    pathname === "/admin"
                      ? { color: "transparent", pointerEvents: "none" }
                      : {}
                  }
                >
                  Connect
                </button>
              </li>
            )}
            {isAdminAuthenticated && (
              <li>
                <button className="logout-btn" onClick={handleLogout}>
                  Logout
                </button>
              </li>
            )}
          </ul>
        </nav>
      </header>
      <Connect isOpen={isConnectOpen} onClose={() => setIsConnectOpen(false)} />
    </>
  );
}

export default Header;
